import Vue from 'vue';
import Vuetify, { VLayout, VIcon, VFlex } from 'vuetify/lib';
import 'vuetify/src/stylus/app.styl';
// import 'material-design-icons-iconfont/dist/material-design-icons.css';

Vue.use(Vuetify, {
  components: { VLayout, VIcon, VFlex },
  iconfont: 'md',
});
